<template>
  <div v-if="showDetails">
    <div id="details">
      <header id="header" class="row pb-1">
        <div :class="`col-xs-12 monit-item bg-${statusColor}`">
          <h5 class="mb-0 pt-1">{{ Object.keys(item).length && item.NAME }}</h5>
          <div class="update"><clock-icon title="" /> {{ updated }}</div>
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'planning' ? 'active' : ''}`"
          @click="selectDetails(1)"
        >
          Programação
        </div>
        <div
          :class="`col-xs-6 monit-tabs   ${active == 'info' ? 'active' : ''}`"
          @click="selectDetails(0)"
        >
          Informações
        </div>
      </header>
      <div class="column details-area pl-2 pr-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <div
            class="days center-xs pt-2"
            :style="` ${item.STATUS == 1 ? 'opacity: 0.5;' : ''}`"
          >
            <b-button-group>
              <b-button
                v-for="(day, index) in weekDays"
                :key="index"
                size="sm"
                style="pointer-events: none; cursor: default"
                :variant="selectedDay(day.name, item.WDAY)"
              >
                {{ day.letter }}
              </b-button>
            </b-button-group>
          </div>
          <div class="info-title">Detalhes</div>
          <div class="col-xs-12 mt-2 info-details">
            <strong>Início:</strong>
            {{ formatDate(item.START_DATE, item.START_TIME) }}<br />
            <strong>Duração:</strong>
            {{ parseMinToHHmm(item.DURATION) }}<br />
            <strong> Conclusão:</strong>
            {{ ending }}
            <br />
            <strong>Expiração:</strong>
            {{ formatDate(item.END_DATE, item.END_TIME) || "nunca" }}
            <div v-if="item.GENERIC">
              <span v-for="(g, i) in item.GENERIC" :key="i">
                <strong>{{ g.NAME }}</strong> {{ g.VALUE }}<br />
              </span>
            </div>
          </div>
          <!-- <div v-if="item.GENERIC" class="info-title">
            Medições
          </div>
          <div class="col-xs-12 info-details mt-2">
            <div class="">
              <div v-if="item.GENERIC" class="generic-details">
                <div v-for="(g, i) in item.GENERIC" :key="i" class="m-0">
                  <span
                    ><strong>{{ g.NAME }}</strong> {{ g.VALUE }}</span
                  >
                </div>
              </div>
            </div>
          </div> -->

          <div class="info-title">Estado</div>
          <div class="col-xs-12 center-xs">
            <strong v-if="item.STATUS == 1"> EXPIRADA </strong>
            <strong v-else-if="item.STATUS == 2"> PARADA </strong>
            <strong v-else-if="item.STATUS == 3"> EM EXECUÇÃO </strong>
            <strong v-else-if="item.STATUS == 4"> EM ESPERA </strong>
            <strong v-else-if="item.STATUS == 5"> DIA NÃO SELECIONADO </strong>
            <strong v-else-if="item.STATUS == 6">
              DESABILITADA POR SENSOR
            </strong>
            <strong v-else-if="item.STATUS == 8">
              BLOQUEADA POR HORÁRIO DE PONTA
            </strong>
          </div>
          <div class="col-xs-12">
            <b-btn
              v-if="item.STATUS == 2"
              size="sm"
              block
              @click="reqPlay"
              variant="3v3"
            >
              <play-icon title="Executar" />PLAY
            </b-btn>
            <b-btn
              v-else-if="item.STATUS != 1"
              size="sm"
              block
              variant="black"
              @click="reqStop"
            >
              <stop-icon title="Parar" />STOP
            </b-btn>
          </div>
          <div class="col-xs-12" v-if="item.STATUS == 3">
            <div class="percent-box">
              <div
                class="percent-progress bg-3v3"
                :style="`width: ${
                  item.STATUS
                    ? calculatePercentage(item.ELAPSED, item.DURATION)
                    : '0'
                }%;`"
              />
              <div class="percent-text">Andamento</div>
              <div class="percent-value">
                {{ calculatePercentage(item.ELAPSED, item.DURATION) }}%
              </div>
            </div>
            <div class="progressDetail">
              <div>
                <span>
                  <strong>Níveis:</strong> {{ item.LEVEL.CURRENT }} /
                  {{ item.LEVEL.TOTAL }}
                </span>
                <span>
                  <strong>Falta:</strong>
                  {{ setRemainingTime(item.DURATION, item.ELAPSED) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="content pl-1 pr-1" v-else>
          <div v-if="item.VALVE.length" class="planning">
            <div class="column pt-1">
              <div :class="`col-xs-12`">
                <div v-for="(level, index) in item.BYLEVEL" :key="index">
                  <div
                    class="levels-card"
                    :style="setLevelBgColor(index, item.LEVEL.CURRENT, 0.15)"
                  >
                    <div
                      class="level-number"
                      :style="setLevelBgColor(index, item.LEVEL.CURRENT, 1)"
                    >
                      {{ level[0].LEVEL }}º nível
                    </div>
                    <div
                      class="v-box"
                      v-for="(valve, vindex) in level"
                      :key="`valvula${vindex}`"
                    >
                      <div
                        :class="`v-tag ${progressColor(
                          item.LEVEL.CURRENT,
                          valve
                        )}`"
                      >
                        <signal-one-alert-icon
                          v-if="valve.STATUS_RF"
                          title=""
                        />
                        <check-icon
                          v-else-if="
                            progressColor(item.LEVEL.CURRENT, valve) ==
                            'bg-pacific-blue'
                          "
                          title="Executado"
                        />
                        <!-- <check-icon
                          v-else-if="progressIcon(item, valve) == 'check'"
                          title="Executado"
                        /> -->
                        <play-icon
                          v-else-if="
                            progressColor(item.LEVEL.CURRENT, valve) == 'bg-3v3'
                          "
                          title="Executando"
                        />
                        <!-- <play-icon
                          v-else-if="progressIcon(item, valve) == 'play'"
                          title="Executando"
                        /> -->
                        <clock-icon
                          v-else-if="
                            progressColor(item.LEVEL.CURRENT, valve) ==
                            'bg-black'
                          "
                          title="Aguardando"
                        />
                        <span v-if="valve.STATUS_RF"> {{ valve.DIR }} </span>
                      </div>

                      <strong class="v-name">{{ valve.NAME }}</strong>

                      <div class="w-100 align-items-end d-flex">
                        <div class="v-details mr-1">
                          <div class="prevision pb-1" v-if="agnStart">
                            <strong>Horário:</strong>
                            {{ `${calcDuration(index, valve.TOTAL_TIME)}`
                            }}<br />
                          </div>
                          <div class="v-line-progress-bg">
                            <div
                              class="v-line-progress"
                              :style="`width: ${calculatePercentage(
                                valve.CURRENT_TIME,
                                valve.TOTAL_TIME
                              )}%; ${setLevelBgColor(
                                index,
                                item.LEVEL.CURRENT,
                                1
                              )}`"
                            ></div>
                          </div>

                          <span style="font-size: 0.9em">{{
                            parseMinToHHmm(valve.CURRENT_TIME) +
                            " / " +
                            parseMinToHHmm(valve.TOTAL_TIME)
                          }}</span>
                        </div>
                        <div
                          class="v-details ml-1"
                          :style="`opacity: ${
                            valve.TOTAL_VOLUME ? '1' : '0.35'
                          };`"
                        >
                          <div class="v-line-progress-bg">
                            <div
                              class="v-line-progress"
                              :style="`width: ${calculatePercentage(
                                valve.CURRENT_VOLUME,
                                valve.TOTAL_VOLUME
                              )}%; ${setLevelBgColor(
                                index,
                                item.LEVEL.CURRENT,
                                1
                              )}`"
                            ></div>
                          </div>
                          <span style="font-size: 0.9em">
                            {{
                              (valve.TOTAL_VOLUME
                                ? valve.CURRENT_VOLUME
                                : "0") +
                              " / " +
                              valve.TOTAL_VOLUME
                            }}
                            m³
                          </span>
                        </div>
                      </div>

                      <div v-if="valve.FERTI.length">
                        <beaker-icon title="" />
                        <strong>FERTI</strong>
                        <div
                          v-for="(ferti, findex) in valve.FERTI"
                          :key="`ferti${findex}`"
                          class="v-ferti"
                        >
                          <div
                            :class="`f-name ${progressColor(
                              item.LEVEL.CURRENT,
                              ferti
                            )}`"
                            v-bgProgress="progressIcon(item, ferti, true)"
                          >
                            {{ ferti.FERTILEVEL }}º
                            <signal-one-alert-icon
                              v-if="ferti.STATUS_RF"
                              title=""
                            />
                            <check-icon
                              v-else-if="
                                progressIcon(item, ferti, true) == 'check'
                              "
                              title=""
                            />
                            <play-icon
                              v-else-if="
                                progressIcon(item, ferti, true) == 'play'
                              "
                              title=""
                            />
                            <clock-icon
                              v-else-if="
                                progressIcon(item, ferti, true) == 'clock'
                              "
                              title=""
                            />
                            <strong> {{ ferti.NAME }} </strong>
                          </div>

                          <div class="d-flex align-items-center">
                            <div class="v-details mr-1">
                              <div class="v-line-progress-bg">
                                <div
                                  class="v-line-progress"
                                  v-bgProgress="progressIcon(item, ferti, true)"
                                  :style="`width: ${calculatePercentage(
                                    ferti.CURRENT_TIME,
                                    ferti.TOTAL_TIME
                                  )}%; ${setLevelBgColor(
                                    index,
                                    item.LEVEL.CURRENT,
                                    1
                                  )}`"
                                ></div>
                              </div>
                              <span style="font-size: 0.9em">
                                {{
                                  parseMinToHHmm(ferti.CURRENT_TIME) +
                                  " / " +
                                  parseMinToHHmm(ferti.TOTAL_TIME)
                                }}
                              </span>
                              <!-- <div class="prevision" v-if="agnStart">
                                <strong>Horário:</strong>
                                {{ `${calcDuration(index, ferti.TOTAL_TIME)}`
                                }}<br />
                              </div> -->
                            </div>
                            <div
                              class="v-details ml-1 pt-1 pb-1"
                              :style="`opacity: ${
                                ferti.TOTAL_VOLUME ? '1' : '0.35'
                              };`"
                            >
                              <div class="v-line-progress-bg">
                                <div
                                  class="v-line-progress"
                                  v-bgProgress="progressIcon(item, ferti, true)"
                                  :style="`width: ${calculatePercentage(
                                    ferti.CURRENT_VOLUME,
                                    ferti.TOTAL_VOLUME
                                  )}%; ${setLevelBgColor(
                                    index,
                                    item.LEVEL.CURRENT,
                                    1
                                  )}`"
                                ></div>
                              </div>
                              <span style="font-size: 0.9em">
                                {{
                                  (ferti.TOTAL_VOLUME
                                    ? ferti.CURRENT_VOLUME
                                    : "0") +
                                  " / " +
                                  ferti.TOTAL_VOLUME
                                }}
                                L
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>Esta agenda não possui válvulas.</div>
        </div>

        <b-modal
          ref="confirmChangeState"
          size="sm"
          centered
          hide-header
          ok-title="Confirmar"
          ok-variant="danger"
          @ok="confirmChangeState"
          @cancel="requestChangeState = {}"
          cancel-title="Cancelar"
        >
          Executar {{ requestChangeState.action }}?
        </b-modal>
      </div>
      <footer>
        <b-btn
          size="sm"
          block
          @click="$emit('close-details')"
          :variant="statusColor"
        >
          Fechar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { cmd } from "@/api";
import { isMobile } from "@/pages/components/helpers.js";
export default {
  name: "schedule-details",
  props: {
    item: Object,
    statusColor: String,
    updated: String,
    ending: String,
    showDetails: Boolean,
    agnStart: String,
  },
  directives: {
    bgProgress: {
      bind(el, binding, vNode) {
        // Checar se está no PLAY
        if (binding.value === "play") {
          el.style.backgroundColor = "#3d9161";
        } else if (binding.value == "clock") {
          el.style.backgroundColor = "rgb(75, 79, 78)";
        } else if (binding.value == "check") {
          el.style.backgroundColor = "#66b0d8";
        }
      },
      update(el, binding, vNode, oldVnode) {
        if (binding.value === "play") {
          el.style.backgroundColor = "#3d9161";
        } else if (binding.value == "clock") {
          el.style.backgroundColor = "rgb(75, 79, 78)";
        } else if (binding.value == "check") {
          el.style.backgroundColor = "#66b0d8";
        }
      },
    },
  },
  data() {
    return {
      active: "planning",
      tabIndex: 0,
      valueTabIndex: 0,
      requestChangeState: {},
      weekDays: [
        {
          letter: "D",
          name: "SUNDAY",
        },
        {
          letter: "S",
          name: "MONDAY",
        },
        {
          letter: "T",
          name: "TUESDAY",
        },
        {
          letter: "Q",
          name: "WEDNESDAY",
        },
        {
          letter: "Q",
          name: "THURSDAY",
        },
        {
          letter: "S",
          name: "FRIDAY",
        },
        {
          letter: "S",
          name: "SATURDAY",
        },
      ],
    };
  },
  watch: {
    item(newValue) {
      const hasScheduleData = newValue && Reflect.has(newValue, "ID");
      if (hasScheduleData) {
        this.formatSchedule(newValue);
      }
    },
  },
  methods: {
    formatSchedule(schedule) {
      const levels = schedule.VALVE;
      const totalLevels = schedule.LEVEL.TOTAL;

      if (levels && totalLevels) {
        const sortedLevels = this.sortLevels(levels);
        // schedule.VALVE = this.formatLevelsIndex(sortedLevels);
        schedule.BYLEVEL = this.groupByLevels(levels, totalLevels);
      }
    },
    formatLevelsIndex(levels) {
      const copyLevels = [...levels];

      return copyLevels.map((level, index) => {
        level.LEVEL = index + 1;

        return level;
      });
    },
    sortLevels(levels) {
      let sortedValves = levels;

      if (levels && levels.length) {
        sortedValves = levels.sort((a, b) => a.LEVEL - b.LEVEL);
      }

      return sortedValves;
    },
    groupByLevels(levels, lenOfLevels) {
      let byLevels = [];

      for (let i = 1; i <= lenOfLevels; i++) {
        let valveLevel = levels.filter((valve) => valve.LEVEL == i);
        if (valveLevel.length) {
          byLevels.push(valveLevel);
        }
      }

      return byLevels;
    },
    selectDetails(idx) {
      let tabs = ["info", "planning"];
      this.active = tabs[idx];
    },
    parseToHHmm(min) {
      let hours = Math.floor(min / 60);
      let minutes = min % 60;
      if (hours >= 24) hours = hours % 24;
      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      let result = hours + ":" + minutes;
      return result;
    },
    parseToMin(time) {
      time = time.split(":");
      let hour = Number(time[0]);
      let minute = Number(time[1]);
      hour = hour * 60;
      return hour + minute;
    },
    calcDuration(level, duration) {
      let prevision = this.parseToMin(this.agnStart);
      duration = Number(duration);
      for (let i = 0; i < this.item.BYLEVEL.length; i++) {
        if (i == level) break;
        else {
          prevision += Math.max(
            ...this.item.BYLEVEL[i].map((e) => Number(e.TOTAL_TIME))
          );
        }
      }
      return `${this.parseToHHmm(prevision)} - ${this.parseToHHmm(
        prevision + duration
      )}`;
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    isMobile(ref) {
      return isMobile(ref);
    },
    parseMinToHHmm(min) {
      let hours = Math.floor(min / 60);
      min = min % 60;
      return ("0" + hours).slice(-2) + ":" + ("0" + min).slice(-2);
    },
    formatDate(date, time) {
      if (!date || date === "2038-01-01") return null;
      let dateSplited = date.split("-");
      let result = dateSplited[2] + "/" + dateSplited[1] + "/" + dateSplited[0];
      if (time) result = `${result} ${this.formatTime(time)}`;
      return result;
    },
    formatTime(time) {
      if (time) {
        let timeSplited = time.split(":");
        return timeSplited[0] + ":" + timeSplited[1];
      }
      return 0;
    },
    setRemainingTime(duration, elapsed) {
      let remainingMin = duration - elapsed;
      let diffSec = remainingMin * 60;
      let diffDays = Math.floor(diffSec / 86400);
      let diffHrs = Math.floor((diffSec % 86400) / 3600);
      let diffMins = Math.floor(((diffSec % 86400) % 3600) / 60);
      let result = ("0" + diffHrs).slice(-2) + ":" + ("0" + diffMins).slice(-2);
      return result;
    },
    valveActive(valve_level, active_level, current_time, total_time) {
      if (valve_level == active_level && current_time < total_time)
        return "active";
      return "";
    },
    setLevelBgColor(current, total, opacity) {
      current += 1;
      let bg = "#fff";
      if (current == total) bg = "#3d9161";
      else if (current < total) bg = "#0288D1";
      else if (current > total) bg = "#4B4F4E";
      if (opacity < 1) {
        bg += "15"; //alpha = 0.15
      }
      return `background-color: ${bg};`;
    },
    //schedule
    progressIcon(item, valve, isFerti) {
      let state = isFerti ? valve.STAT : item.STATUS;
      let valve_level = valve.LEVEL;
      let active_level = item.LEVEL.CURRENT;
      let current_time = valve.CURRENT_TIME;
      let total_time = valve.TOTAL_TIME;
      let result = "clock";
      if (active_level != 0) {
        if (valve_level < active_level) result = "check";
        else if (valve_level == active_level) {
          if (current_time >= total_time) result = "check";
          else {
            if (state == 1) result = "play";
          }
        }
      }
      return result;
    },
    calcTimeToEnd(item) {
      let state = isFerti ? valve.STAT : item.STATUS;
    },
    progressColor(active_level, valve) {
      let status_rf = valve.STATUS_RF;
      let valve_level = valve.LEVEL;
      let current_time = valve.CURRENT_TIME;
      let total_time = valve.TOTAL_TIME;
      let bg = "bg-red text-red";

      if (!status_rf) {
        if (active_level != 0) {
          if (valve_level == active_level) {
            if (current_time >= total_time) bg = "bg-pacific-blue";
            else bg = "bg-3v3";
          } else if (valve_level < active_level) bg = "bg-pacific-blue";
          else if (valve_level > active_level) bg = "bg-black";
        } else bg = "bg-black";
      }
      return bg;
    },
    reqStop() {
      this.openChangeState(2);
    },
    reqPlay() {
      this.openChangeState(0);
    },
    openChangeState(set) {
      let action = set ? "STOP" : "PLAY";
      this.requestChangeState = {
        set,
        action,
      };
      this.$refs.confirmChangeState.show();
    },
    confirmChangeState() {
      if (!!this.requestChangeState.action) {
        let data = {
          id: this.item.ID,
          setState: this.requestChangeState.set,
          action: "AGN_" + this.requestChangeState.action,
        };
        cmd
          .schedulechangestate(data)
          .then((ret) => {
            console.log(ret.log, ret.alert);
          })
          .catch((err) => console.log(err));
      } else console.log("Erro ao detectar mudança de estado.");
      this.$refs.confirmChangeState.hide();
    },
    selectedDay(name, WDAY) {
      if (WDAY[name] == 1) return "3v3";
      else return "red";
    },
  },
};
</script>

<style scoped>
.percent-box {
  background-color: #8a8a8a;
  border-radius: 10px;
}
.text-red {
  color: #ffff;
}
.percent-progress {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
  background: -webkit-linear-gradient(
    135deg,
    #3d9161 25%,
    #3b865c 25%,
    #3b865c 50%,
    #3d9161 50%,
    #3d9161 75%,
    #3b865c 75%
  );
  background-size: 80px 80px;
  animation: bar-animation 3s linear infinite;
  -webkit-animation: bar-animation 3s linear infinite;
}
.percent-text,
.percent-value {
  z-index: 2;
}
.prevision {
  text-align: left;
  font-size: 0.9em;
  /* color: var(--text-gray-primary); */
}
@keyframes bar-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 80px 80px;
  }
}
.planning .levels-card {
  margin-bottom: 8px;
  /* margin-right: 12px; */
  padding-bottom: 3px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.level-number {
  margin-top: 0 !important;
  color: white;
  padding: 3px;
  text-align: center;
  border-radius: 4px 4px 0 0;
}
.progressDetail {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.9em;
  color: var(--text-gray-primary);
}
.progressDetail span:first-child {
  margin-right: 30px;
}
.planning .v-box {
  text-align: center;
  display: inline-block;
  width: 98%;
  /* width: 48%; */
  position: relative;
  background-color: white;
  border-radius: 2px;
  border: 1px solid rgb(212, 212, 212);
  padding: 3px 3px;
  margin: 5px 1%;
}
.planning .v-box .v-tag {
  font-size: 0.8em;
  position: absolute;
  width: 50px;
  color: white;
  border-radius: 4px;
}
.planning .v-box .v-name {
  text-align: left;
  width: calc(100% - 50px);
  padding-left: 5px;
  float: right;
  color: var(--text-gray-primary);
}
.planning .v-box .v-ferti {
  width: 90%;
  margin: auto 5%;
}
.planning .v-box .v-ferti .f-name {
  border-radius: 5px 5px 0 0;
  padding: 1px 5px 1px 5px;
  color: white;
  text-align: start;
  font-size: 0.84em;
}
.planning .v-box .v-ferti .f-name > strong {
  color: white !important;
}
.planning .v-box .v-details {
  display: inline-block;
  width: 49%;
  font-size: 0.9em;
  color: var(--text-gray-primary);
}
.v-line-progress-bg {
  position: relative;
  margin-bottom: 3px;
  height: 5px;
  width: 100%;
  background-color: #dbdbdb;
}
.v-line-progress {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}
#details .content h5 {
  color: #fff;
}
</style>
